// ブラウザの自動スクロール復元を無効化して最上端にスクロール
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual'
}
window.scrollTo(0, 0)

// splashが表示されている間はスクロールを無効化
document.body.classList.add('noscroll')
document.documentElement.classList.add('noscroll')

// タイミング定数
const TIMING = {
  logoInStart: 100,
  logoOutStart: 1300,
  logoExitDelay: 200,
  fadeDuration: 1600,
  noscrollRemoveDelay: 300,
  mvElementsFadeInDelay: 600,
  catchphraseDelay: 200,
  carouselInitialDelay: 8000,
  carouselNormalDelay: 12000,
  slideTransitionDuration: 8000
}

// DOM要素を一度だけ取得
const DOM = {
  splash: document.getElementById('splash'),
  splashLogo: document.querySelector('.splash-logo'),
  globalNavWrap: document.querySelector('.globalNavWrap'),
  scrollGuide: document.querySelector('.scrollGuide'),
  hamburgerWrap: document.querySelector('.hamburgerWrap'),
  catchphrase: document.querySelector('.catchphrase'),
  slides: document.querySelectorAll('.carousel-slide')
}

// カスタムカルーセル
const carousel = {
  currentIndex: 0,
  totalSlides: DOM.slides.length,
  autoplayInterval: null,
  nextSlideTimeout: null,
  animatingRemoveTimeouts: [], // スケールアニメーション終了用タイマー

  showSlide(index) {
    // 前回のタイマーをクリア
    clearTimeout(this.nextSlideTimeout)

    const nextIndex = (index + 1) % this.totalSlides

    DOM.slides.forEach((slide, i) => {
      const isActive = i === index
      slide.classList.toggle('active', isActive)
      slide.classList.remove('first-load')
      slide.style.opacity = slide.style.transition = ''

      if (isActive) {
        slide.classList.remove('next', 'animating')
        slide.classList.add('animating')
      } else {
        clearTimeout(this.animatingRemoveTimeouts[i])
        this.animatingRemoveTimeouts[i] = setTimeout(
          () => slide.classList.remove('animating'),
          4000
        )
      }
    })

    this.currentIndex = index

    // opacity transition 完了後、次のスライドに .next クラスを追加
    this.nextSlideTimeout = setTimeout(() => {
      DOM.slides.forEach(slide => slide.classList.remove('next'))
      DOM.slides[nextIndex].classList.add('next')
    }, TIMING.slideTransitionDuration)
  },

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.totalSlides
    this.showSlide(nextIndex)
  },

  startAutoplay() {
    if (this.autoplayInterval) clearInterval(this.autoplayInterval)

    this.autoplayInterval = setInterval(() => {
      this.nextSlide()
    }, TIMING.carouselNormalDelay)
  },

  clearAutoplay() {
    clearInterval(this.autoplayInterval)
    clearTimeout(this.nextSlideTimeout)
    this.animatingRemoveTimeouts.forEach(timeout => clearTimeout(timeout))
    this.animatingRemoveTimeouts = []
    this.autoplayInterval = this.nextSlideTimeout = null
  }
}

// カルーセルアニメーション開始
const startCarousel = () => {
  // 最初のスライド変更まで carouselInitialDelay 待つ
  setTimeout(() => {
    carousel.nextSlide() // slide 0 → slide 1

    // 以降は carouselNormalDelay ごとにスライド変更
    carousel.startAutoplay()
  }, TIMING.carouselInitialDelay)
}

// MV要素のフェードイン
const fadeInMVElements = () => {
  if (DOM.globalNavWrap) DOM.globalNavWrap.classList.add('visible')
  if (DOM.scrollGuide) DOM.scrollGuide.classList.add('visible')
  if (DOM.hamburgerWrap) DOM.hamburgerWrap.classList.add('visible')

  // splash の fade を待たずに、すぐに carousel を開始
  startCarousel()

  setTimeout(() => {
    if (DOM.catchphrase) DOM.catchphrase.classList.add('visible')
  }, TIMING.catchphraseDelay)
}

// Splashフェードアウト
const fadeSplash = () => {
  document.documentElement.style.setProperty('--splash-fade-duration', `${TIMING.fadeDuration}ms`)
  DOM.splash.classList.add('hide')

  // noscrollを先に削除
  setTimeout(() => {
    document.body.classList.remove('noscroll')
    document.documentElement.classList.remove('noscroll')
  }, TIMING.noscrollRemoveDelay)

  // その後MV要素をフェードイン
  setTimeout(fadeInMVElements, TIMING.mvElementsFadeInDelay)
}

// ロゴアニメーション
const animateSplashLogo = () => {
  window.scrollTo(0, 0)
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
  setTimeout(() => DOM.splashLogo.classList.add('in'), TIMING.logoInStart)
  setTimeout(() => DOM.splashLogo.classList.add('exit'), TIMING.logoOutStart)
  setTimeout(fadeSplash, TIMING.logoOutStart + TIMING.logoExitDelay)
}

window.onload = animateSplashLogo